module.exports = __webpack_public_path__ + "static/media/alipay.46ded3e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/alipay.svg
// module id = 1551
// module chunks = 0